import React from 'react';
import "./PrivacyPolicy.css"; // ✅ add this

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <div className="policy-card shadow-lg">
        <h2 className="policy-title text-center mb-3">Privacy Policy</h2>
        <div className="underline"></div>

        <p>
          At <strong>eSevaLinks</strong>, we respect your privacy and are committed to protecting your
          personal information. This Privacy Policy explains how we collect, use, and safeguard your
          data when you visit our website.
        </p>

        <h5>1. Information We Collect</h5>
        <p>
          We may collect personal information such as your name, email, and contact details when you
          fill out forms or subscribe to updates.
        </p>

        <h5>2. How We Use Information</h5>
        <p>
          Your data helps us improve our services, respond to inquiries, and send you relevant updates
          about government schemes.
        </p>

        <h5>3. Data Protection</h5>
        <p>
          We implement appropriate security measures to protect your data from unauthorized access or
          misuse. We never sell or share your personal information with third parties.
        </p>

        <h5>4. Updates</h5>
        <p>
          This Privacy Policy may be updated periodically. Continued use of our website implies
          acceptance of the updated terms.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
